/* eslint-disable vue/padding-lines-in-component-definition */
import Swal from 'sweetalert2'
import type { CustomWindow } from '@/misc/custom-window'

declare let window: CustomWindow

// Set defaults
Swal.mixin({
  width: 400,
  heightAuto: false,
  padding: '2.5rem',
  buttonsStyling: false,
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-secondary',
  },
  confirmButtonColor: undefined,
  cancelButtonColor: undefined
})

window.Swal = Swal

export default Swal
